/**
 * Left sidebar composing toolbar, placed racks, unplaced racks, and settings.
 */

import React from 'react';
import EditorToolbar from './EditorToolbar';
import PlacedRacksList from './PlacedRacksList';
import UnplacedRacksList from './UnplacedRacksList';
import SettingsPanel from './SettingsPanel';

const EditorSidebar: React.FC = () => {
  return (
    <div className="w-64 bg-white border-r border-gray-200 flex flex-col overflow-hidden flex-shrink-0">
      <EditorToolbar />
      <div className="flex-1 overflow-y-auto">
        <PlacedRacksList />
        <UnplacedRacksList />
      </div>
      <SettingsPanel />
    </div>
  );
};

export default EditorSidebar;
